import { getMiddlewateClient } from "../MiddlewareClientProvider";

export const loadSpaceLogStream = async (id: string) => {
    const mangerClient = getMiddlewateClient().getManagerClient(id);
    const logStreamCurrent = (await mangerClient.getLogStream()) as unknown as ReadableStream;

    return logStreamCurrent;
};
